export const WELLNESS_CONFIG_TABS = ['Settings', 'Invitation Template', 'Candidates'] as const;

export const WELLNESS_RESULTS_TABS = ['Summary Results', 'Candidate Results'] as const;

export const WELLNESS_ASSESSMENT_OPTIONS = [
  { label: 'DASS-21 (Depression, Anxiety & Stress)', value: 'DASS21' },
  { label: 'GAD-7 (Generalised Anxiety Disorder)', value: 'GAD7' },
  { label: 'PHQ-9 (Patient Health Questionnaire)', value: 'PHQ9' },
] as const;

export const SEVERITY_BADGE_CLASS: Record<string, string> = {
  Normal:             'bg-emerald-100 text-emerald-700',
  Minimal:            'bg-emerald-100 text-emerald-700',
  Mild:               'bg-yellow-100 text-yellow-700',
  Moderate:           'bg-amber-100 text-amber-700',
  Severe:             'bg-red-100 text-red-700',
  'Extremely Severe': 'bg-rose-100 text-rose-800',
};

export const RISK_BADGE_CLASS: Record<string, string> = {
  Low:      'bg-emerald-100 text-emerald-700',
  Mild:     'bg-yellow-100 text-yellow-700',
  Moderate: 'bg-amber-100 text-amber-700',
  High:     'bg-red-100 text-red-700',
};


export const SEVERITY_BAND_COLOR_CLASS: Record<string, string> = {
  Normal: 'bg-emerald-400',
  Minimal: 'bg-emerald-400',
  Mild: 'bg-yellow-400',
  Moderate: 'bg-amber-400',
  'Moderately Severe': 'bg-red-500',
  Severe: 'bg-red-500',
  'Extremely Severe': 'bg-rose-700',
};